import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import { LazyLoadImage } from 'react-lazy-load-image-component';

import { api, useAPIContext } from '../../api/context';
import { Title } from '../../utils/title';
import { useTiktokContext, tiktokPixel } from '../../utils/tiktok';
import { useMetaContext, metaPixel } from '../../utils/meta';
import toast from '../../utils/toast';
import socials from '../../utils/socials';
import Layout from './Layout';
import styles from './_04_Socials.module.scss';

const KEY = 'tiktok';

const _04_Socials = () => {

  const { token } = useAPIContext();
  const [ loading, setLoading ] = useState(true);

  const navigate = useNavigate();

  const { tiktokClickId } = useTiktokContext();
  const { fbclid, fbc, fbp } = useMetaContext();

  useEffect(() => {

    if (!token) {
      return;
    }

    /*
     * Track completion
     */
    const track = () => {

      const trackTiktok = () => {

        if (!tiktokClickId) {
          return;
        }

        if (tiktokClickId === 'noad') {
          return;
        }

        api(token).v1.socials.tiktok.track
          .query()
          .then(res => {
            if (res.status === 200) {

              const event_name = 'CompleteRegistration';
              const event_id = res.body.event_ids[event_name];

              const page_url = window.location.href;

              try {
                tiktokPixel.track(
                  event_name,
                  {},
                  { event_id },
                );
              } catch (err) {
                console.log(err);
              }

              api(token).v1.socials.tiktok.track
                .post({
                  event_name,
                  event_id,

                  page_url: page_url,
                  click_id: tiktokClickId,
                })
                .then(res => {
                  console.log(res);
                })
                .catch(err => {
                  console.log(err);
                });

            } else {
              console.log(res.body);
            }
          })
          .catch(err => {
            console.log(err);
          });
      };

      const trackMeta = () => {

        api(token).v1.meta.track
          .query()
          .then(res => {
            if (res.status !== 200) {
              console.log(res.body);
              return;
            }

            const event_name = 'CompleteRegistration';
            const event_id = res.body.event_ids[event_name];
            const page_url = window.location.href;

            try {
              metaPixel.track(event_name, {}, { eventID: event_id });
            } catch (err) {
              console.log(err);
            }

            api(token).v1.meta.track
              .post({
                event_name,
                event_id,
                page_url,
                fbclid: fbclid || '',
                fbc: fbc || '',
                fbp: fbp || '',
              })
              .catch(err => console.log(err));
          })
          .catch(err => console.log(err));
      };

      trackTiktok();
      trackMeta();
    };

    /*
     * Check completion
     */
    api(token).v1.socials.query()
      .then(res => {
        setLoading(false);

        if (res.body.data[KEY]) {
          track();
          navigate('/campaigns');
        }
      })
      .catch(err => {
        setLoading(false);
        toast.show(toast.KIND.WARNING, err);
      });

  }, [token, navigate, tiktokClickId, fbclid, fbc, fbp]);

  const connect = () => {

    setLoading(true);

    api(token).v1.socials
      .post(
        { provider: KEY },
        { target: window.location.href },
      )
      .then(res => {
        if (res.status === 200) {
          window.location.href = res.body.url;
        } else {
          setLoading(false);
        }
      })
      .catch(err => {
        setLoading(false);
        toast.show(toast.KIND.WARNING, err);
      });

  };

  return (
    <>
      <Title value='Socials' />
      <Layout step='socials' auth={true}>
        <div className={styles.root}>

          <p>⚠️ Important: Only members who connect their TikTok are eligible for free products</p>

          <LazyLoadImage
            alt={socials.ITEM[KEY].label}
            src={socials.ITEM[KEY].image}
          />

          <button
            type='button'
            onClick={() => connect()}
            disabled={loading}>

            Connect

          </button>

        </div>
      </Layout>
    </>
  );
};

export default _04_Socials;